import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { SarFaslAmozeshiService } from 'src/app/Service/SarFaslAmozeshi/SarFaslAmozeshi.service';

@Component({
  selector: 'app-SarFaslAmozeshiEdit',
  templateUrl: './SarFaslAmozeshiEdit.component.html',
  styleUrls: ['./SarFaslAmozeshiEdit.component.scss']
})
export class SarFaslAmozeshiEditComponent implements OnInit {

  Token:String=""
  EditRecord:Number

  constructor(
    private SarFaslAmozeshi_Service:SarFaslAmozeshiService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.EditSarFaslAmozeshi=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))
    

    this.Nav_Service.CheckValidPage(this.Token,23).subscribe(
      data=>{
        this.SarFaslAmozeshi_Service.GetSingle(this.Token,this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
    
          }
        )
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )

  }

    //#region  Form Add

    EditSarFaslAmozeshi:FormGroup;

    get_Form_Id(){
      return this.EditSarFaslAmozeshi.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditSarFaslAmozeshi.get('Title') as FormControl;
    }

    //#endregion

    InProccessing:boolean=false

    SubmitEditSarFaslAmozeshi(){
      var Record:General_Interface =Empty_General_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      this.InProccessing=true
      this.SarFaslAmozeshi_Service.EditSarFaslAmozeshi(Record,this.Token).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("The entered title already exists in the list.")
          }
          else{

            this.Alertify_Service.SuccessMessage("Information saved successfully.")
          }
        }
      )
    }



}
